import { FieldValidation } from '../../core/domain/transaction/fieldValidation';

export const minLength = (length: number): FieldValidation => (value) => {
	return value.length >= length;
};
